import gregorian from 'react-date-object/calendars/gregorian';
import { parseJalali } from './chartDates';
export const customerName = row => [row?.first_name, row?.last_name].filter(Boolean).join(' ') || `کاربر ${row?.id || row?.user_id || ''}`;
export const crmNumber = (value, gold = false) => value === undefined ? '—' : Number(value || 0).toLocaleString('fa-IR', {
  maximumFractionDigits: gold ? 3 : 0
});
export const crmDate = value => value ? new Date(typeof value === 'string' && /^\d{4}-\d{2}-\d{2} /.test(value) ? value.replace(' ', 'T') + 'Z' : value).toLocaleString('fa-IR', {
  timeZone: 'Asia/Tehran',
  dateStyle: 'short',
  timeStyle: 'short'
}) : '—';
export const states = {
  normal: 'عادی',
  new: 'جدید',
  active: 'فعال',
  inactive: 'غیرفعال',
  vip: 'ویژه',
  needs_help: 'نیازمند راهنمایی',
  open: 'باز',
  progress: 'در حال انجام',
  done: 'انجام‌شده',
  canceled: 'لغوشده',
  queued: 'در صف',
  complete: 'پایان پردازش',
  pending: 'در انتظار',
  processing: 'در حال ارسال',
  stored: 'ثبت در سایت',
  accepted: 'پذیرفته‌شده توسط پیامک',
  failed: 'ناموفق',
  unknown: 'نامشخص؛ نیازمند بررسی',
  skipped: 'ارسال نشد'
};
export const permissionNames = {
  customers: 'مشاهده مشتریان',
  financial: 'اطلاعات مالی',
  contact: 'ارسال فردی',
  bulk: 'ارسال گروهی',
  tasks: 'یادداشت و پیگیری',
  reports: 'گزارش‌ها',
  settings: 'تنظیمات و دسترسی‌ها'
};
export function gregorianDay(value) {
  const parsed = parseJalali(value);
  if (!parsed) throw Error('تاریخ شمسی معتبر وارد کنید؛ مانند ۱۴۰۵/۰۷/۱۶');
  return parsed.date.convert(gregorian).format('YYYY-MM-DD');
}
export function dueDate(day, time) {
  const normalized = String(time).replace(/[۰-۹٠-٩]/g, c => String(c.charCodeAt(0) > 1775 ? c.charCodeAt(0) - 1776 : c.charCodeAt(0) - 1632));
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(normalized)) throw Error('ساعت معتبر مانند ۱۰:۳۰ وارد کنید');
  return new Date(`${gregorianDay(day)}T${normalized}:00+03:30`).toISOString();
}
export const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, c => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
})[c]);
export function downloadFile(name, content, type = 'text/plain;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([content], {
      type
    })),
    a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function exportCustomers(rows) {
  const cell = value => '"' + String(value ?? '').replace(/^[=+@-]/, "'$&").replace(/"/g, '""') + '"';
  const data = [['نام', 'همراه', 'کد سیستم', 'مانده ریالی', 'مانده طلایی', 'آخرین معامله'], ...rows.map(r => [customerName(r), r.phone_number, r.system_code, r.balance_rial, r.balance_gold, crmDate(r.last_trade_at)])];
  downloadFile('crm-customers.csv', '\uFEFF' + data.map(row => row.map(cell).join(',')).join('\r\n'), 'text/csv;charset=utf-8');
}
export function statementHtml(data) {
  let rial = Number(data.opening.rial),
    gold = Number(data.opening.gold);
  const rows = data.items.map(row => {
    rial += Number(row.credit_rial || 0) - Number(row.debit_rial || 0);
    gold += Number(row.credit_gold || 0) - Number(row.debit_gold || 0);
    return `<tr>${[row.id, crmDate(row.created_at), row.description, crmNumber(row.credit_rial), crmNumber(row.debit_rial), crmNumber(row.credit_gold, true), crmNumber(row.debit_gold, true), crmNumber(rial), crmNumber(gold, true)].map(v => '<td>' + escapeHtml(v) + '</td>').join('')}</tr>`;
  }).join('');
  return `<!doctype html><html lang="fa" dir="rtl"><meta charset="utf-8"><title>صورت‌حساب آبشده خرّمی</title><style>body{font:14px Tahoma;padding:24px;color:#163b3b}table{border-collapse:collapse;width:100%;font-size:12px}td,th{padding:8px;border:1px solid #ddd}h1{font-size:22px}@media print{button{display:none}thead{display:table-header-group}}</style><h1>آبشده خرّمی · صورت‌حساب ${escapeHtml(customerName(data.customer))}</h1><p>همراه: ${escapeHtml(data.customer.phone_number)} · تهیه: ${escapeHtml(crmDate(data.generated_at))}</p><p>از ${escapeHtml(crmDate(data.start))} تا ${escapeHtml(crmDate(data.end))}</p><p>مانده ابتدای بازه: ${escapeHtml(crmNumber(data.opening.rial))} ریال / ${escapeHtml(crmNumber(data.opening.gold, true))} گرم</p><table><thead><tr>${['سند', 'تاریخ', 'شرح', 'بستانکار ریال', 'بدهکار ریال', 'بستانکار طلا', 'بدهکار طلا', 'مانده ریال', 'مانده طلا'].map(t => '<th>' + t + '</th>').join('')}</tr></thead><tbody>${rows}</tbody></table><p>مانده پایان بازه: ${escapeHtml(crmNumber(rial))} ریال / ${escapeHtml(crmNumber(gold, true))} گرم</p><p>عدد منفی نشان‌دهنده بدهی است. این گزارش موجودی را تغییر نمی‌دهد.</p><button onclick="window.print()">چاپ / ذخیره PDF</button></html>`;
}
